import Jodit, { IJodit } from 'jodit'
import 'jodit/build/jodit.min.css'
import React, { useEffect, useRef } from 'react'
import { style } from 'styled-system'

export type EditorConfig = Partial<IJodit['options']>

export interface TextEditorProps {
  value?: string
  config?: EditorConfig
  style?: any
  onChange?: (value: string) => void
  onBlur?: (value: string) => void
  tabIndex?: number
}

export const TextEditor: React.FunctionComponent<TextEditorProps> = ({
  value,
  onChange,
  onBlur,
  tabIndex,
}) => {
  const textArea = useRef<any>(null)

  const config = {
    useTableProcessor: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    iframe: true,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    removeButtons: [
      'eraser',
      'copyformat',
      'redo',
      'fullsize',
      'symbol',
      'print',
      'about',
    ],
  } as EditorConfig

  useEffect(() => {
    const blurHandler = (x: any) => onBlur && onBlur(x)
    const changeHandler = (x: any) => onChange && onChange(x)

    if (textArea && textArea.current) {
      const jodit = new (Jodit as any)(
        textArea.current,
        config,
        style
      ) as IJodit
      jodit.value = value || ''
      jodit.events.on('blur', () => blurHandler(jodit.value))
      jodit.events.on('change', () => changeHandler(jodit.value))
      jodit.workplace.tabIndex = tabIndex || -1
    }
  }, [])

  // hacked style -> because of Office UI Farbic Panel higher z-index

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `.jodit_toolbar_popup-inline-target { display: none, z-index: 10000000000 !important } .jodit_dialog_box { z-index: 10000000000 !important }`,
        }}
      />
      <textarea ref={textArea} />
    </>
  )
}
